import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import { logMessage } from '../../../../util/Logging'
import { requireAuthContext } from '../../authorization/GlobalAuthContext'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

type GetEntityTypeParameters = { id: EntityTypeId }

const getEntityType = async ({ id }: GetEntityTypeParameters): Promise<EntityType | null> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/types/${id.toString()}`, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
    },
  }).then(async (response) => {
    switch (response.status) {
      case 200:
        return EntityType.fromJsonString(await response.text())
      case 404:
        logMessage(`Got status ${response.status} from getEntityType endpoint`, 'warning')
        return null
      default:
        throw Error(`Unexpected response code ${response.status} from getEntityType endpoint`)
    }
  })
}

export default getEntityType
